import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "../../../Styles";
import { DataObj, getLabelFromKey, ReportData } from "../../../Definitions";
import { CheckBox, CheckStyles } from "../..";

interface Lvl3_Props {
  reportData?: ReportData
  onReportDataChange: (data: ReportData) => void
}

export default function ReportModalLvl3({ reportData, onReportDataChange }: Lvl3_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  const checkboxes = useMemo(() => {
    const dataParameters: DataObj[] = [
      // "locationId", 
      "animal_group_id", 
      // "conditionId", 
      // "attentionId", 
      "milestone_id"
    ];

    return dataParameters.map((param, index) => {
      const label = getLabelFromKey(param);
      
      return (
        <CheckBox
          key={index}
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue}
          isChecked={reportData?.dataParameter?.includes(param)}
          onChange={() => {
            const isChecked = reportData?.dataParameter?.includes(param);
            const updatedParams = isChecked
              ? reportData && reportData.dataParameter?.filter(id => id !== (param))
              : [...(reportData?.dataParameter || []), param];
            onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, dataParameter: updatedParams });
          }}
        />
      );
    });
  }, [onReportDataChange, reportData, t]);
  
  return(
    <div style={{ width: "fit-content", display: "flex", flexWrap: "wrap", columnGap: "60px", rowGap: "10px", margin: "0 auto", flexDirection: mobileXs ? "column" : "row" }}>  
      {checkboxes}
    </div>
  )
}